import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UserUndelete($user_uid: String!){
        user_undelete (user_uid: $user_uid) {
            success
        }
    }
`;

export async function userUndelete(user_uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ user_undelete: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { user_uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_undelete;
}
